import { userHasLevel } from "../../../engine/AuthRoute";
import { roles } from "../../../utils/constants";
import { Tag } from "antd";
import {
  mainTypesPrestation,
  typesPrestation,
} from "../../../utils/typesPrestation";
import { renderAdress } from "../../../shared/container/Addresses/AddresseItem/AddresseHelpers";

export const columnsInstitutionsList = [
  {
    title: "Nom",
    dataIndex: "name",
    key: "name",
    render: (n, record) => n,
    width: "15%",
    sorter: (a, b) => {
      return a.name.localeCompare(b.name);
    },
  },
  {
    title: "Mandant global",
    dataIndex: "principal",
    key: "principal",
    render: (n, record) => n?.name || "-",
    width: "15%",
    sorter: (a, b) => {
      return a?.principal?.name?.localeCompare(b?.principal?.name);
    },
  },
  {
    title: "Domaine",
    dataIndex: "mainType",
    width: "15%",
    key: "mainType",
    sorter: (a, b) => {
      return a?.mainType?.localeCompare(b?.mainType);
    },
  },
  {
    title: "Adresse par défaut",
    dataIndex: "defaultAddress",
    width: "15%",
    key: "defaultAddress",
    render: (a, i) => renderAdress(a, false, i),
    // sorter: (a, b) => {
    //   return a?.mainType?.localeCompare(b?.mainType);
    // },
  },
  {
    title: "Tags",
    dataIndex: "tags",
    width: "15%",
    key: "tags",
    render: (n, record) => n?.map(tag => <Tag>{tag.label}</Tag>),
  },
  {
    title: "Facturation groupée",
    dataIndex: "groupedBilling",
    width: "15%",
    key: "groupedBilling",
    render: (groupedBilling, record) => {
      return groupedBilling ? "Oui" : "Non";
    },
    sorter: (a, b) => {
      // Sorter by boolean groupedBilling
      return a.groupedBilling - b.groupedBilling;
    },
  },
];

export const inputsInstitutionsList = [
  {
    parentLabel: null,
    children: [
      {
        label: "Recherche",
        placeholder: "Nom, domaine, intervention, tags",
        name: "search",
        value: "",
        type: "input",
        capitalize: false,
        col: 8,
      },
      {
        label: "Filtre par mandant",
        name: "principal",
        type: "dynamic-select",
        allowClear: true,
        width: 300,
        endPoint: "principals",
        itemsCallBack: (principals, form) => {},
        itemCallback: item => {
          return {
            key: item._id,
            label: `${item.name}`,
            value: item._id,
          };
        },
        col: 8,
      },
      {
        label: "Filtre par type",
        name: "type",
        disabled: true,
        value: undefined,
        allowClear: true,
        type: "select",
        selectContent: typesPrestation,
        selectType: "group",
        col: 8,
      },
    ],
  },
];
